/**
 * SectionHeaderDivider - универсальный заголовок секции профиля
 * с иконкой в фирменном стиле, текстом и опциональным бейджем.
 */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { ZERDE_COLORS } from '../constants';

export interface SectionHeaderDividerProps {
  id: string;
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  badge?: React.ReactNode;
}

const SectionHeaderDivider: React.FC<SectionHeaderDividerProps> = ({
  id,
  icon,
  title,
  subtitle,
  badge
}) => (
  <Box
    id={id}
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1.75,
      pb: 1.5,
      borderBottom: '2px solid #e2e8f0',
      scrollMarginTop: '24px'
    }}
  >
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 38,
        height: 38,
        borderRadius: '10px',
        bgcolor: 'rgba(21, 112, 239, 0.08)',
        color: ZERDE_COLORS.primary,
        flexShrink: 0
      }}
    >
      {icon}
    </Box>
    <Box
      sx={{
        flexGrow: 1,
        minWidth: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        flexWrap: 'wrap'
      }}
    >
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h6" sx={{ fontWeight: 700, color: '#1e293b', fontSize: '1.25rem', lineHeight: 1.3 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" sx={{ color: '#64748b', fontSize: '0.85rem', mt: 0.25 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {badge && (
        <Box sx={{ flexShrink: 0 }}>
          {badge}
        </Box>
      )}
    </Box>
  </Box>
);

export default SectionHeaderDivider;
